// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__LbCBu","label":"Section_label__1wKeU","contentWrap":"Section_contentWrap__2-vzl","footer":"Section_footer__3de0g","footerInner":"Section_footerInner__3F8Qj"};